export type GitStatus = 'connected' | 'not-connected';

export interface DemoQlikApp {
  id: string;
  name: string;
  fileName: string;
  icon: 'bars' | 'pie' | 'line' | 'cart';
  gitStatus: GitStatus;
  syncLabel: string;
  repository?: string;
  branch?: string;
  lastSync?: string;
  lastSyncBy?: string;
  action: 'Check in' | 'Check out';
}

export const consumerSalesAppId = '50aa7670-712a-4144-ac1e-743eb7fd05fb';
export const checkoutUserAppId = '8663f3e1-8aad-49b2-9157-010bda52e0bb';

export const demoApps: DemoQlikApp[] = [
  {
    id: consumerSalesAppId,
    name: 'Consumer Sales Demo',
    fileName: 'Consumer Sales Demo.qvf',
    icon: 'bars',
    gitStatus: 'connected',
    syncLabel: 'Up to date',
    repository: 'bohua/consumer-sales-demo',
    branch: 'main',
    lastSync: '2026-07-20 12:00',
    lastSyncBy: 'bohua',
    action: 'Check in',
  },
];

export const defaultCommitMessage = 'Update KPIs and add region filter';
